import { Heading } from '@/components/ui/heading'
import { AppCollapsible } from '@components'
import Disclaimer from '@components/Disclaimer'
import Panel from '@components/Panel'
import { useNavigate, useParams } from '@solidjs/router'
import { useSetups } from '@stateApp'
import { type ParentProps, Show, createEffect } from 'solid-js'
import { createSignal } from 'solid-js'
import { useService } from 'solid-services'
import { css } from 'styled-system/css'
import { Box, Grid } from 'styled-system/jsx'
import Chart from './Chart'
import Chat from './Chat'
import Mobile from './Mobile'
import Overview from './Overview'
import { useSingle } from './state'

export default function RouteContainer(props: ParentProps) {
  const { setSetupId, setupQuery } = useService(useSingle)()
  const { deleteSetupResource } = useService(useSetups)()
  const params = useParams()
  const navigate = useNavigate()

  createEffect(() => {
    setSetupId(params.id)
  })

  createEffect(() => {
    if (deleteSetupResource.state === 'ready') {
      navigate('/')
    }
  })

  return (
    <Show when={setupQuery.data}>
      <>
        <Panel
          p="14px"
          height="calc(var(--vh) * 100)"
          class={css({
            position: 'relative',
            overflowY: 'auto',
            width: 'full',
            pb: 0,
          })}
        >
          <DesktopView />
          <MediumDesktopView />
          <MobileView />
          <Disclaimer />
        </Panel>
      </>
    </Show>
  )
}

const DesktopView = () => {
  return (
    <Grid
      gap="14px"
      gridTemplateColumns="402px minmax(0, 1fr) 384px"
      height="100%"
      display={{
        base: 'grid',
        xlDown: 'none',
      }}
    >
      <Overview />
      <Chart />
      <Chat />
    </Grid>
  )
}

const MediumDesktopView = () => {
  const [activeCol, setActiveCol] = createSignal<string | null>('overview')

  return (
    <Grid
      gap={3}
      gridTemplateColumns="1fr 2fr"
      alignItems="start"
      display={{
        base: 'none',
        xlDown: 'grid',
        mdDown: 'none',
      }}
    >
      <Grid>
        <AppCollapsible
          hideBorder
          open={activeCol() === 'overview'}
          onOpenChange={({ open }) => setActiveCol(open ? 'overview' : 'chat')}
          headerContent={<Heading>Overview</Heading>}>
          <Overview />
        </AppCollapsible>
        <AppCollapsible
          hideBorder
          open={activeCol() === 'chat'}
          onOpenChange={({ open }) => setActiveCol(open ? 'chat' : 'overview')}
          headerContent={<Heading>Chat</Heading>}>
          <Chat />
        </AppCollapsible>
      </Grid>
      <Chart />
    </Grid>
  )
}

const MobileView = () => {
  return (
    <Box
      display={{
        base: 'none',
        mdDown: 'block',
      }}
      mx="-14px"
      mt="-14px"
    >
      <Mobile />
    </Box>
  )
}
